module.exports = __webpack_public_path__ + "static/slide-areas-7d7c8f73b504843f282b74a678f020e6.svg";